<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/77/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/77/title-1.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）企业新引进的正（副）高级职称人才须从本市行政区域外首次引进，以首次签订的劳动合同或工作协议时间为准。
                        </div>
                        <div class="des">
                            （二）申请享受人才待遇奖励政策的，所获职称应为通过评审取得（不含取得职业资格证书），以所获职称市（州）及以上人社（职改）部门通知批文时间为准。同一人在都江堰工作期间只能申报1次。企业发放内部使用的职称证书（人力资源社会保障部、人力资源社会保障厅授权在蓉央企或国企直接发放的职称证书除外）不属于本申请办理范围。
                        </div>
                        <div class="des">
                            （三）与本地企业新签订劳动合同的正、副高级职称人才在岗工作时间不得少于一年。
                        </div>
                        <div class="des">
                            （四）初次签订劳动合同的公司注册地须在都江堰市，个人社保参保地须与公司注册地一致。
                        </div>
                        <div class="des">
                            （五）申请人申报时需满足首次签订劳动合同企业的在职人员身份。
                        </div>
                        <div class="des">
                            （六）申请人应遵守中华人民共和国宪法和法律，具有良好的品行和职业道德，因涉嫌违法犯罪正在接受司法调查尚未作出结论的人员、尚未解除党纪、政纪处分或正在接受纪律审查的人员均不得申报补贴。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/77/title-2.png" alt="" />
                    <div class="content">
                        对都江堰市企业新引进人才，分别给予正高级职称人才一次性2万元/人、副高级职称人才一次性1万元/人奖励。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/77/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）企业需于每年3月底前，向都江堰市人社局递交申报材料（所需资料扫码获取详情）。
                        </div>
                        <div class="des">
                            （二）由企业将其在职情况和个人所得税完税证明等相关佐证材料汇总，提交都江堰市人社局进行审核。
                        </div>
                        <div class="des">
                            （三）所需提交资料须由所在企业统一汇总后报送并加盖公章。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/77/title-4.png" alt="" />
                    <div class="content">
                        相关经费由市财政局从人才专项资金中划拨至行业主管部门。
                    </div>
                </div>

                <div class="contact">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number" style="padding-left: 2.4rem;">
                            <span class="label">都江堰市人社局:</span>
                            <div>
                                <a href="tel:028-89741025">028-89741025</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">联系地址：</span>
                            都江堰市天府大道639号
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/77/code.png" />
                    <img class="text" src="../assets/imgs/77/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 3.94rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4rem;
            }
        }
    }
}
</style>
